export class VendorApiModel {
    vendorID:number;
    vendorName:string;
    vendorAutoID:number;
}
